import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ModelIcon } from './ModelIcon';
import { modelFit } from '../data/kit';
import { getAccent } from '../utils/accent';
export function WhyThreeSection() {
  return <section className="w-full bg-paper py-20 lg:py-28" aria-labelledby="por-que-3" data-id="element-372" data-mp="26s7uow9e3mkh">
      <div className="mx-auto max-w-5xl px-5" data-id="element-373" data-mp="2bsc9mhung98l">
        <h2 id="por-que-3" className="font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl" data-id="element-374" data-mp="2bpznrtlrteq9">
          ¿Por qué 3 modelos?
        </h2>
        <p className="mt-4 text-lg text-muted" data-id="element-375" data-mp="2krpcuss6k1kv">Porque no todos tenemos los mismos recursos.</p>

        <ul className="mt-10 divide-y divide-line border-y border-line" data-id="element-376" data-mp="2pkigfdbwx3vd">
          {modelFit.map(fit => {
          const a = getAccent(fit.accent);
          return <li key={fit.model} className="grid items-center gap-3 py-6 md:grid-cols-[1fr_auto_1fr] md:gap-8" data-id="element-377" data-mp="2zi6of4yj47vh">
                <p className="text-lg text-ink" data-id="element-378" data-mp="34fyh416zzy0q">{fit.profile}</p>
                <ArrowRightIcon className="hidden h-5 w-5 text-muted md:block" aria-hidden="true" data-id="element-379" data-mp="1bwdrm46kjzjv" />
                <p className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-380" data-mp="16xalegeurnab">
                  <span className={`inline-flex items-center gap-2 rounded-full ${a.bg} px-4 py-1.5 font-display font-black text-white`} data-id="element-381" data-mp="16zdmbvhjn0tt">
                    <ModelIcon accent={fit.accent} className="h-4 w-4" data-id="element-382" data-mp="xx4cl7u3nbhh" />
                    {fit.model}
                  </span>
                  <span className="text-muted" data-id="element-383" data-mp="1ulk2x6519ovn">{fit.verdict}</span>
                </p>
              </li>;
        })}
        </ul>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-384" data-mp="1pq4sko68ib3z">
          <p className="text-lg text-muted" data-id="element-385" data-mp="1kvr2906fiu66">
            No queremos convencerte de que existe <span className="italic" data-id="element-386" data-mp="1gw9tnxvphgws">“el mejor negocio”</span>.
          </p>
          <p className="font-display text-2xl font-black leading-tight" data-id="element-387" data-mp="2dd4kld3mocua">
            Queremos ayudarte a encontrar el que vos estés dispuesto a ejecutar.
          </p>
        </div>
      </div>
    </section>;
}